var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 17.4166C14.3724 17.4166 17.9168 13.8722 17.9168 9.49992C17.9168 5.12766 14.3724 1.58325 10.0002 1.58325C5.62791 1.58325 2.0835 5.12766 2.0835 9.49992C2.0835 13.8722 5.62791 17.4166 10.0002 17.4166ZM8.23224 7.81019C8.61071 8.02912 9.09499 7.89979 9.31392 7.52133C10.0715 6.42461 11.536 7.88492 10.3353 8.59872C10.1195 8.72702 9.83725 8.94059 9.62257 9.2022C9.4193 9.44992 9.2326 9.79059 9.21065 10.2093C9.20785 10.2363 9.20642 10.2638 9.20642 10.2916C9.20642 10.7288 9.56086 11.0833 9.99809 11.0833C10.6015 11.0833 10.7164 10.7627 10.8323 10.4391C10.9069 10.231 10.9819 10.0217 11.1877 9.89575C11.8421 9.49515 12.3751 8.78562 12.3752 7.91658C12.3752 6.60491 11.3118 5.54158 10.0002 5.54158C9.12008 5.54158 8.35283 6.02069 7.94338 6.72851C7.72445 7.10698 7.85378 7.59126 8.23224 7.81019ZM9.20642 12.6666C9.20642 12.2294 9.56086 11.8749 9.99809 11.8749C10.4353 11.8749 10.7898 12.2294 10.7898 12.6666C10.7898 13.1038 10.4353 13.4583 9.99809 13.4583C9.56086 13.4583 9.20642 13.1038 9.20642 12.6666Z",
    fill: "url(#paint0_radial_1461_81670)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1461_81670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0002 9.49992) rotate(90) scale(7.91667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A7287"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionCircle);
export default __webpack_public_path__ + "static/media/icon-question-circle.9b042287b2d683003ca61e60e2769788.svg";
export { ForwardRef as ReactComponent };